import React from 'react';
import { Button, View, Text } from '../elements';
import Theme from '../Theme';
import { observer } from 'mobx-react';
import cxs from 'cxs/component';
const styleButtom = {
    width: '50%',
    borderColor: Theme.color.primary,
    borderWidth: 1,
    borderRadius: 5,
    borderStyle: 'solid',
};
const styleText = {
    marginTop: '14px',
    marginBottom: '14px',
};
const IdaVuelta = observer(({ value, toggled, disabled, origin, destination, onPress, onPressToggle, }) => {
    return (React.createElement(View, null,
        React.createElement(View, { center: true, row: true, style: { height: Theme.size.bar, width: '100%' } },
            React.createElement(Button, { style: Object.assign(Object.assign({}, styleButtom), { backgroundColor: !value ? Theme.color.primary : 'white' }), disabled: disabled, onClick: () => onPress(false) },
                React.createElement(Text, { center: true, style: Object.assign(Object.assign({}, styleText), { color: !value ? 'white' : 'black' }) }, `${'SÓLO IDA'}`)),
            React.createElement(Button, { style: Object.assign(Object.assign({}, styleButtom), { backgroundColor: value ? Theme.color.primary : 'white' }), disabled: disabled, onClick: () => onPress(true) },
                React.createElement(Text, { center: true, style: Object.assign(Object.assign({}, styleText), { color: value ? 'white' : 'black' }) }, `${'IDA-VUELTA'}`))),
        React.createElement(View, { flex: true, row: true, style: {
                // height: Theme.size.bar,
                marginTop: '5px',
                padding: '1px',
                borderStyle: 'solid',
                borderColor: 'black',
                borderWidth: '1px',
                borderRadius: 5,
            } },
            React.createElement(Button, { style: {
                    width: '100%',
                    backgroundColor: Theme.color.traficWhite,
                }, onClick: onPressToggle },
                React.createElement(View, { flex: true, row: true, center: true, style: {
                        justifyContent: 'space-around',
                    } },
                    React.createElement(TextWrapper, { big: true, center: true, toggled: !toggled, styles: styleText }, `${origin}`),
                    React.createElement(Text, { big: true, center: true, style: Object.assign({}, styleText) }, `--->`),
                    React.createElement(TextWrapper, { big: true, center: true, toggled: toggled, styles: styleText }, `${destination}`))))));
});
const TextWrapper = cxs('p')(({ toggled, styles }) => {
    return Object.assign(Object.assign({}, styles), { fontSize: 'small', color: toggled ? 'green' : 'black' });
});
export default IdaVuelta;



//////////////////
// WEBPACK FOOTER
// ./src/components/IdaVuelta.tsx
// module id = 561
// module chunks = 0